var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldEmptyWalletTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.88A3.97 3.97 0 0 0 1 19c0 2.21 1.79 4 4 4a4 4 0 0 0 2.64-1C8.47 21.27 9 20.2 9 19a3.999 3.999 0 0 0-6.5-3.12zm3.14 4.01-1.25.75c-.12.08-.26.11-.39.11-.25 0-.5-.13-.64-.36-.21-.36-.1-.82.26-1.03l.89-.53v-1.08a.74.74 0 0 1 .74-.75c.41 0 .75.34.75.75v1.5c0 .26-.14.51-.36.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.85 7.75h-1.5v-3.8c0-.27-.24-.4-.4-.4-.05 0-.1.01-.15.03L4.87 6.57c-.53.2-.87.7-.87 1.27v.67c-.91.68-1.5 1.77-1.5 3V7.84c0-1.19.73-2.25 1.84-2.67l7.94-3c.22-.08.45-.12.67-.12 1 0 1.9.81 1.9 1.9v3.8zM21.5 15.5a.5.5 0 0 1-.49.5h-1.46c-.53 0-1.01-.39-1.05-.91-.03-.31.09-.6.29-.8a.95.95 0 0 1 .7-.29H21c.29.01.5.23.5.5v1z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12.95c.55 0 1-.45 1-1v-.44c0-2.07-1.69-3.76-3.76-3.76H6.26c-.85 0-1.63.28-2.26.76-.91.68-1.5 1.77-1.5 3v1.78c0 .38.4.62.76.5.56-.19 1.15-.29 1.74-.29 3.03 0 5.5 2.47 5.5 5.5 0 .72-.19 1.51-.49 2.21-.16.36.09.79.48.79h7.25c2.07 0 3.76-1.69 3.76-3.76v-.19c0-.55-.45-1-1-1h-.87c-.96 0-1.88-.59-2.13-1.52-.2-.76.04-1.5.54-1.98.37-.38.88-.6 1.44-.6h1.02zM9 12.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75H9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldEmptyWalletTime);
export default __webpack_public_path__ + "static/media/vuesax-bold-empty-wallet-time.bcf46909928eb4dac7f5683ec6b5a615.svg";
export { ForwardRef as ReactComponent };